import { css } from '@/styled-system/css';

export const starGroup = css({
  display: 'inline-flex',
  gap: 'xs',
});

export const starButton = css({
  background: 'none',
  borderStyle: 'none',
  cursor: 'pointer',
  padding: '0',
  fontSize: '28px',
  lineHeight: '1',
  color: 'hpxGrey400',
  transitionProperty: 'color',
  transitionDuration: '0.15s',
  transitionTimingFunction: 'ease',
  _disabled: {
    cursor: 'default',
    opacity: 0.6,
  },
});

export const starFilled = css({
  color: 'hpxYellow500',
});
